import React, { useState } from 'react';
import silverLogo from '../assets/silverRateWork.png';

export default function GoldTestingReport() {
  const [fields, setFields] = useState({
    reportDate: '',
    reportSerial: '',
    clientName: '',
    address: '',
    number: '',
    dateReceived: '',
    reportNumber: '',
    weight: '',
    silverAg: '',
    platinumPt: '',
    palladiumPd: '',
    purityKg: '',
  });

  const set = (key, val) => setFields(f => ({ ...f, [key]: val }));

  const handlePrint = () => window.print();
  const handlePDF = () => {
    if (window.html2pdf) {
      const el = document.getElementById('reportPageContent');
      window.html2pdf().set({ margin: 0.5, filename: 'KW-Gold-Report.pdf', html2canvas: { scale: 2 }, jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' } }).from(el).save();
    } else {
      alert('PDF library not loaded');
    }
  };

  return (
    <>
      <div id="reportPageContent">
        <div className="report-page">
          {/* Header */}
          <div className="header">
            <div className="header-left">
              <div className="company-name">KW<sup>TM</sup></div>
              <div className="company-tagline">Gold &amp; Silver Testing Laboratory</div>
            </div>
            <div className="header-center">
              <img src={silverLogo} alt="KW Logo" className="logo" style={{ height: '60px', width: '60px' }} />
            </div>
            <div className="header-right" style={{ textAlign: 'right' }}>
              <div className="urdu-text">کے ڈبلیو</div>
              <div className="urdu-tagline">گولڈ اینڈ سلور ٹیسٹنگ لیبارٹری</div>
            </div>
          </div>

          {/* Top Info */}
          <div className="top-info">
            <span>DATE: <input value={fields.reportDate} onChange={e => set('reportDate', e.target.value)} type="date" style={{ border: 'none', borderBottom: '1px solid #999', padding: '2px', fontSize: '11px' }} /></span>
            <span>SERIAL NO: <input value={fields.reportSerial} onChange={e => set('reportSerial', e.target.value)} type="text" style={{ border: 'none', borderBottom: '1px solid #999', padding: '2px', width: '150px', fontSize: '11px' }} /></span>
          </div>

          <div className="report-title">Gold Testing Report</div>

          {/* Main Content */}
          <div className="main-content">
            <div className="client-section">
              <div className="section-title">Client</div>
              <div className="field-row"><div className="field-label">Name:</div><input value={fields.clientName} onChange={e => set('clientName', e.target.value)} type="text" className="field-value" placeholder="Enter client name" /></div>
              <div className="field-row"><div className="field-label">Address:</div><input value={fields.address} onChange={e => set('address', e.target.value)} type="text" className="field-value" placeholder="Enter address" /></div>
              <div className="field-row"><div className="field-label">Number:</div><input value={fields.number} onChange={e => set('number', e.target.value)} type="text" className="field-value" placeholder="Enter client number" /></div>
            </div>
            <div className="sample-section">
              <div className="section-title">Sample Identification</div>
              <div className="field-row"><div className="field-label">Date Received:</div><input value={fields.dateReceived} onChange={e => set('dateReceived', e.target.value)} type="date" className="field-value" /></div>
              <div className="company-info-box">
                <div className="kw-logo">KW<sup>TM</sup></div>
                <div style={{ fontWeight: 'bold' }}>Gold &amp; Silver Testing Laboratory</div>
                <div>TEL: 021-34806318, 021-34856018, 021-3685037</div>
                <div>MOBILE: 0333-3188888</div>
              </div>
            </div>
          </div>

          {/* Report Details */}
          <div className="main-content">
            <div className="client-section">
              <div className="field-row"><div className="field-label">Report:</div><input value={fields.reportNumber} onChange={e => set('reportNumber', e.target.value)} type="text" className="field-value" placeholder="Enter report number" /></div>
              <div className="field-row"><div className="field-label">Weight:</div><input value={fields.weight} onChange={e => set('weight', e.target.value)} type="number" className="field-value" placeholder="Enter weight" step="0.01" /></div>
              <div className="field-row"><div className="field-label">Silver AG.%:</div><input value={fields.silverAg} onChange={e => set('silverAg', e.target.value)} type="number" className="field-value" placeholder="xxxxx" step="0.01" /></div>
              <div className="field-row"><div className="field-label">Platinum PT.%:</div><input value={fields.platinumPt} onChange={e => set('platinumPt', e.target.value)} type="number" className="field-value" placeholder="xxxxx" step="0.01" /></div>
              <div className="field-row"><div className="field-label">Palladium PD.%:</div><input value={fields.palladiumPd} onChange={e => set('palladiumPd', e.target.value)} type="number" className="field-value" placeholder="xxxxx" step="0.01" /></div>
              <div className="field-row"><div className="field-label">Purity / KG:</div><input value={fields.purityKg} onChange={e => set('purityKg', e.target.value)} type="text" className="field-value" placeholder="xxxxx" /></div>
            </div>
            <div className="sample-section">
              <div className="right-card">
                <div className="card-title">KW<sup>TM</sup><div className="card-sub">Gold &amp; Silver Testing Laboratory</div></div>
                <div className="card-row">SERIAL NO: {fields.reportSerial}</div>
                <div className="card-row">TEL NO: 021-34806318</div>
                <div className="card-row">MOBILE: 0333-3188888</div>
                <div className="card-box">
                  <div className="box-cell"></div>
                  <div className="box-cell"></div>
                </div>
              </div>
              <div className="disclaimer">
                We are not responsible if the Gold is not taken back.<br />
                <span style={{ direction: 'rtl', display: 'block' }}>اگر سونا واپس نہیں لیا جاتا تو ہم اس کے ذمہ دار نہیں ہیں</span>
                KW Lab is not responsible for this analysis
              </div>
            </div>
          </div>

          <div className="lab-use-only">LAB USE ONLY</div>

          <div className="test-method">
            <div className="method-box">
              <div className="method-title">TEST METHOD NAME</div>
              <div className="method-name">GOLD ALLOYS DETERMINATION</div>
            </div>
            <div className="method-box">
              <div className="method-title">ANALYTICAL METHOD USED</div>
              <div className="method-name">FIRE ASSAY/AQUA REGIA DEGESTION</div>
            </div>
          </div>

          <div className="tested-by">
            <div className="tested-box">
              <div className="tested-title">TESTED BY</div>
              <div className="tested-name">عَبْدُ الصَّمَدِ الرَّحْمَانِيّ</div>
            </div>
            <div className="ceo-box">
              <div className="ceo-title">KW<sup>TM</sup></div>
              <div className="ceo-subtitle">GOLD &amp; SILVER LABORATORY</div>
              <div className="ceo-subtitle">CEO</div>
            </div>
          </div>

          <div className="footer">"Thank you for your trust in KW Gold &amp; Silver Testing Laboratory"</div>
        </div>
      </div>

      <div className="button-container no-print">
        <button className="btn-pdf" onClick={handlePDF}>📄 PDF</button>
        <button className="btn-print" onClick={handlePrint}>🖨️ Print</button>
      </div>
    </>
  );
}
